<div class="container">
  <!-- Stepper Header -->
  <div class="stepper-container">
    <div class="stepper">
      <div class="step" [class.active]="currentStep >= 1" [class.completed]="currentStep > 1">
        <div class="step-circle">
          <mat-icon *ngIf="currentStep > 1">check</mat-icon>
          <span *ngIf="currentStep <= 1">1</span>
        </div>
        <div class="step-label">Upload Files</div>
      </div>

      <div class="step-line" [class.active]="currentStep >= 2"></div>

      <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
        <div class="step-circle">
          <mat-icon *ngIf="currentStep > 2">check</mat-icon>
          <mat-spinner *ngIf="currentStep === 2" diameter="24"></mat-spinner>
          <span *ngIf="currentStep < 2">2</span>
        </div>
        <div class="step-label">Processing</div>
      </div>

      <div class="step-line" [class.active]="currentStep >= 3"></div>

      <div class="step" [class.active]="currentStep >= 3" [class.completed]="currentStep >= 3">
        <div class="step-circle">
          <mat-icon *ngIf="currentStep >= 3">
            {{ result?.errors?.length > 0 ? 'error' : 'check' }}
          </mat-icon>
          <span *ngIf="currentStep < 3">3</span>
        </div>
        <div class="step-label">Complete</div>
      </div>
    </div>
  </div>

 
  <div class="main-card">

   
    <div class="step-content" *ngIf="currentStep === 1">
      <h2 class="section-title">Upload PEME Checkins</h2>
      <p class="section-description">Upload Excel checkins file</p>

      <form #pemeCheckinsForm="ngForm">
       
        <mat-form-field appearance="outline" color="primary" class="full-width">
          <mat-label>Client</mat-label>
          <input type="text" matInput [formControl]="clientControl" [matAutocomplete]="auto" required>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayClient.bind(this)"
            (optionSelected)="onClientSelected($event.option.value)">
            <mat-option *ngFor="let client of filteredClients | async" [value]="client">
              {{client.dname}}
            </mat-option>
          </mat-autocomplete>
          <mat-error>Client is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" color="primary" class="full-width">
          <mat-label>Is Wearable</mat-label>
          <mat-select [(ngModel)]="pemeCheckins.isWearable" name="isWearable" required>
            <mat-option [value]="1">Yes</mat-option>
            <mat-option [value]="0">No</mat-option>
          </mat-select>
          <mat-error>Is Wearable is required</mat-error>
        </mat-form-field>

        
        <div class="file-upload-section">
          <button color="primary" class="file-button" type="button" mat-stroked-button (click)="excelFileInput.click()">
            <mat-icon>table_chart</mat-icon>
            Excel Checkins File
          </button>
          <input hidden (change)="onExcelFileSelected($event)" #excelFileInput name="excelFile" type="file"
            accept=".xls, .xlsx" required />

          <div class="file-info" *ngIf="pemeCheckins.excelFile?.name">
            <mat-icon class="file-icon">description</mat-icon>
            <span class="file-name">{{ pemeCheckins.excelFile?.name }}</span>
            <button mat-icon-button (click)="removeExcelFile()" class="remove-btn">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <div class="action-buttons">
          <button type="button" color="primary" class="upload-btn"
            [disabled]="!pemeCheckinsForm.valid || !pemeCheckins.client || pemeCheckins.isWearable === null || !pemeCheckins.excelFile || uploading"
            (click)="upload()" mat-raised-button>
            <mat-icon *ngIf="!uploading">check_circle</mat-icon>
            <mat-spinner *ngIf="uploading" diameter="20" class="btn-spinner"></mat-spinner>
            {{ uploading ? 'Validating...' : 'Validate Upload' }}
          </button>
        </div>
      </form>
    </div>

    
    <div class="step-content" *ngIf="currentStep === 2">
      <div class="processing-container">
        <mat-spinner diameter="60" color="primary"></mat-spinner>
        <h2 class="section-title" style="margin-top: 24px;">Processing...</h2>
        <p class="section-description">Please wait while we validate your file.</p>
      </div>
    </div>

  
    <div class="step-content" *ngIf="currentStep === 3">

     
      <div class="result-container" *ngIf="result?.success && (!result?.errors || result.errors.length === 0)">
        <div class="success-header">
          <mat-icon class="result-icon success">check_circle</mat-icon>
          <h2 class="result-title">{{ pemeCheckins.commit ? 'Upload Complete!' : 'Validation Successful!' }}</h2>
        </div>

        <div class="success-message">
          <mat-icon>info</mat-icon>
          {{ result.message }}
        </div>

        <div class="stats-row">
          <div class="stat-item">
            <span class="stat-value">{{ result.totalRows }}</span>
            <span class="stat-label">Total Rows</span>
          </div>
          <div class="stat-item" *ngIf="pemeCheckins.commit">
            <span class="stat-value">{{ result.insertedRows }}</span>
            <span class="stat-label">Inserted Rows</span>
          </div>
        </div>

        <div class="action-row">
          <button *ngIf="!pemeCheckins.commit" mat-raised-button color="primary" (click)="promoteToUpload()"
            class="action-btn">
            <mat-icon>cloud_upload</mat-icon>
            Proceed to Upload
          </button>

          <button mat-raised-button color="accent" (click)="resetForm()" class="action-btn">
            <mat-icon>refresh</mat-icon>
            Upload Another
          </button>
        </div>
      </div>

     
      <div class="result-container" *ngIf="!result?.success || result?.errors?.length > 0">
        <div class="error-header">
          <mat-icon class="result-icon error">error</mat-icon>
          <h2 class="result-title">Validation Failed</h2>
        </div>

        <div class="error-message">
          <p><strong>Error:</strong> {{ result?.message || 'Unknown error occurred' }}</p>
        </div>

        <div class="failed-details" *ngIf="result?.errors?.length > 0">
          <h3>
            <mat-icon color="warn">warning</mat-icon>
            Validation Errors ({{ result.errors.length }})
          </h3>
          <p class="error-summary">Please fix the following issues and re-upload:</p>

          <div class="error-list">
            <div class="error-item" *ngFor="let error of result.errors; let i = index">
              <div class="error-header-item">
                <mat-icon color="warn">error_outline</mat-icon>
                <span class="error-number">Error {{ i + 1 }} of {{ result.errors.length }}</span>
                <span class="error-row" *ngIf="error.row > 0">Row {{ error.row }}</span>
              </div>
              <div class="error-body">
                <div class="error-message-box">
                  <strong>Error:</strong> {{ error.error || error.message || error }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <button mat-raised-button color="accent" (click)="resetForm()" class="reset-btn">
          <mat-icon>refresh</mat-icon>
          Try Again
        </button>
      </div>

    </div>
  </div>
</div>
